import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Navbar from "./components/navbar/Navbar";
import Project from "./components/Project";
import Contact from "./components/contact/Contact";
import Aboutme from "./components/Aboutme";
import Home from "./Home";
import { Route, Routes } from "react-router-dom";
import { motion } from "framer-motion";

function App() {
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      const x = e.clientX;
      const y = e.clientY;
      setCursorPosition({ x, y });
    };

    document.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);


  return (
    <>
      <Sbody className="second-body">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<Aboutme />} />
          <Route path="/project" element={<Project />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        {/* //mousemove// */}
        <MouseAnimation
          x={cursorPosition.x}
          y={cursorPosition.y}>
            Hulesh
            </MouseAnimation>
      </Sbody>
    </>
  );
}

const Sbody = styled.div`
.hello{
  color: white;
}
  cursor: pointer;
  width: 90%;
  margin: 0 auto;
  border-radius: 16px;
  border: 1px solid rgba(24, 23, 36, 0.3);
  padding: 0 15px;

  @media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    width: 100%;
    padding: 0;
  }

  @media (max-width: 480px) {
    width: 100%;
    padding: 0;
  }
 
`;

const MouseAnimation = styled(motion.div)`

  position: fixed;
  top: ${({ y }) => `${y}px`};
  left: ${({ x }) => `${x}px`};
  width: 100px;
  height: 100px;
  border-radius: 50%;
  pointer-events: none;
 
  z-index: -1;
  transform: translate(-50%, -50%);
  filter: blur(50px);
  animation: cursorAnimation 3s ease-in-out infinite;

  @keyframes cursorAnimation {
    0% {
      background-image: linear-gradient(45deg, #ff0080, #8000ff);
    }
    50% {
      background-image: linear-gradient(45deg, #00ff80, #0080ff);
    }
    100% {
      background-image: linear-gradient(45deg, #ff0080, #8000ff);
    }
  }
 
`;


export default App;
